import React, { useCallback, useEffect, useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import moment from 'moment';

import { addZeroLessTen } from 'as-ui-kit/utils/time';
import styles from './styles.modules.scss';
import { classes } from 'as-ui-kit/utils/styles';

const CountdownTimer = ({licenseInfo}) => {
    const [timeComponents, setTimeComponents] = useState();
    const [endTime, setEndTime] = useState();

    const calculateTimeLeft = useCallback(() => {
        if (!endTime) {
            return;
        }

        const diff = moment.duration(endTime.diff(new Date()));
        if (diff.asSeconds() < 0) {
            if (!timeComponents || timeComponents.seconds > 0) {
                setTimeComponents({
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                });
            }
            return;
        }

        setTimeComponents({
            days: Math.trunc(diff.asDays()),
            hours: diff.asDays() > 0 ? diff.hours() : Math.trunc(diff.asHours()),
            minutes: diff.minutes(),
            seconds: diff.seconds()
        });
    }, [endTime, timeComponents]);

    const calculateTimerValue = useCallback(() => {
        if (!licenseInfo || !licenseInfo.searchAccessRemainingTime) {
            return;
        }

        if (endTime) {
            setTimeout(() => {
                calculateTimeLeft();
            }, 1000);
        } else {
            const timespan = moment.duration(licenseInfo.searchAccessRemainingTime);
            const finish = moment().add(timespan);
            setEndTime(finish);
            setTimeComponents({
                days: Math.trunc(timespan.asDays()),
                hours: timespan.asDays() > 0 ? timespan.hours() : Math.trunc(timespan.asHours()),
                minutes: timespan.minutes(),
                seconds: timespan.seconds() - 1
            });
        }
    }, [licenseInfo, endTime, calculateTimeLeft]);

    useEffect(() => {
        calculateTimerValue();
    }, [calculateTimerValue]);

    const timerJSX = useMemo(() => {
        if (!timeComponents){
            return null;
        }

        return (
            <div className={styles['timer']}>
                {timeComponents.days > 0 && (
                    <>
                        <div className={styles['part']}>
                            {addZeroLessTen(timeComponents.days)}
                        </div>
                        <div className={styles['colon']}>
                            {':'}
                        </div>
                    </>
                )}
                <div className={styles['part']}>
                    {addZeroLessTen(timeComponents.hours)}
                </div>
                <div className={styles['colon']}>
                    {':'}
                </div>
                <div className={styles['part']}>
                    {addZeroLessTen(timeComponents.minutes)}
                </div>
                <div className={styles['colon']}>
                    {':'}
                </div>
                <div className={classes(styles['part'], styles['seconds'])}>
                    {addZeroLessTen(timeComponents.seconds)}
                </div>
            </div>
        );

    }, [timeComponents]);

    return timerJSX;
};

export default CountdownTimer;

CountdownTimer.propTypes = {
    licenseInfo: PropTypes.object
};
